import { Navigate } from "react-router-dom";

export const PublicRoute: React.FunctionComponent<any> = ({ children }) => {
  const user = localStorage.getItem("contactId");
  if (user) {
    return <Navigate to={"/home"} />;
  }
  return children;
};
